import api from "./api";

// Layout do Meu Painel do usuário logado (PO1-3438). layout = null quer dizer
// "ainda não personalizou": a tela usa a sugestão inicial.
export async function getLayout() {
  const { data } = await api.get("/meu-painel/layout");
  return data && Array.isArray(data.layout) ? data.layout : null;
}

export async function saveLayout(layout) {
  const { data } = await api.put("/meu-painel/layout", { layout });
  return data ? data.layout : layout;
}

export async function resetLayout() {
  await api.delete("/meu-painel/layout");
  return null;
}
